<template>
  <PrepTasks
    team="components"
    :team-filter="['veg','protein','starch','sauciers','misc']"
    show-late-warnings
    :late-warning-priority-deadlines="lateWarningPriorityDeadlines"
    :shorts-only="shortsOnly"
    :hide-shorts="hideShorts"
    :sort-fn="sortByPriority"
    always-show-garnish
  />
</template>

<script>

import PrepTasks from '@/components/tasks/PrepTasks';
import {DEFAULT_PRIORITY_DEADLINES, fetchPriorityDeadlines} from '@/utils/tasks/priority-deadlines';

export default {
  name: "ComponentTasks",
  components: {PrepTasks},
  props: {
    shortsOnly: {type: Boolean, default: false, required: false},
    hideShorts: {type: Boolean, default: false, required: false},
  },
  data() {
    return {
      lateWarningPriorityDeadlines: DEFAULT_PRIORITY_DEADLINES.components
    }
  },
  async mounted() {
    const deadlines = await fetchPriorityDeadlines();
    this.lateWarningPriorityDeadlines = deadlines.components;
  },
  methods: {
    sortByPriority(a, b) {
      const key = ({source: {production_priority}, title}) => `${production_priority || '999'} ${title}`
      return key(a).localeCompare(key(b));
    }
  }
}
</script>

<style scoped>

</style>
